import { IUserProfileState } from './userProfileContext';
import { TUserProfileAction, UserProfileActionTypes } from './userProfileActions';

export const userProfileReducer = (state: IUserProfileState, action: TUserProfileAction): IUserProfileState => {
	switch (action.type) {
		case UserProfileActionTypes.SET_USER_FOR_USER_INFO:
			return {
				...state,
				userForUserInfo: action.payload.userForUserInfo,
			};
		case UserProfileActionTypes.CHANGE_USER_INFO_VISIBLE_FORM:
			return {
				...state,
				userInfoVisibleForm: action.payload.userInfoVisibleForm,
			};
		default:
			return state;
	}
};
